<div class="sticky !bg-[#fff] top-0 !p-0">
  <div
    class="flex justify-between items-center sticky top-0 !bg-[#dee2e6] p-4 !pl-[31px] !pr-[40px]"
  >
    <div class="flex justify-start items-center gap-8 !bg-[#dee2e6]">
      <h3 class="project-plan">Project Plan</h3>
      <span
        class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
        >Responsibility Matrix</span
      >
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="flex justify-end">
    <app-progress-bar
      [progress]="stage2Progress"
      [sectionId]="'section2'"
      [selectedSection]="selectedSection"
      [sectionName]="'Project Plan'"
    >
    </app-progress-bar>
  </div>
</div>
<div class="flex pt-[6px] pr-6 pb-6 pl-6 !px-[40px]">
  <div class="main-section mt-[6px]">
    <div class="table-scroll">
      <div class="card-container shadow-custom rounded-lg">
        <table class="w-full table-auto table-striped">
          <thead style="width: 100%; background: #dee2e6; color: black">
            <tr>
              <th class="w-1/6 !text-left">Activities</th>
              <th class="!text-left">Responsible</th>
              <th class="!text-left">Accountable</th>
              <th class="!text-left">Consulted</th>
              <th class="!text-left">Informed</th>
            </tr>
          </thead>
          <tbody *ngFor="let work_package of items">
            <ng-container *ngIf="work_package.children.length > 0">
              <tr *ngFor="let child of work_package.children">
                <!-- Display child name -->
                <td class="!text-left">{{ child.name }}</td>

                <!-- Responsible field -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="child.responsible"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #stakeholderResponsible
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              stakeholderResponsible.value,
                              child,
                              'responsible'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <!-- Accountable field -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="child.accountable"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #stakeholderAccountable
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              stakeholderAccountable.value,
                              child,
                              'accountable'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <!-- Consulted field -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="child.consulted"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #stakeholderConsulted
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              stakeholderConsulted.value,
                              child,
                              'consulted'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <!-- Informed field -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="child.informed"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #stakeholderInformed
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              stakeholderInformed.value,
                              child,
                              'informed'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="work_package.children.length === 0">
              <tr>
                <!-- Display work_package name if no children -->
                <td class="!text-left">
                  {{ work_package.name }}
                </td>

                <!-- Responsible field for work_package without children -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="work_package.responsible"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #wpStakeholderresponsible
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              wpStakeholderresponsible.value,
                              work_package,
                              'responsible'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <!-- Accountable field for work_package without children -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="work_package.accountable"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #wpStakeholderAccountable
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              wpStakeholderAccountable.value,
                              work_package,
                              'accountable'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <!-- Consulted field for work_package without children -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="work_package.consulted"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #wpStakeholderConsulted
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              wpStakeholderConsulted.value,
                              work_package,
                              'consulted'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>

                <!-- Informed field for work_package without children -->
                <td>
                  <mat-form-field appearance="outline" class="w-full h-16">
                    <mat-select
                      [(ngModel)]="work_package.informed"
                      panelClass="custom-panel"
                    >
                      <mat-option class="!p-0">
                        <input
                          #wpStakeholderInformed
                          type="text"
                          (keydown)="onKeyDown($event)"
                          placeholder="Add new stakeholder"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="
                            addStakeholder(
                              wpStakeholderInformed.value,
                              work_package,
                              'informed'
                            )
                          "
                          placeholder="Add Custom Stakeholder"
                          class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96] !text-left p-[16px] !border-[1px] !border-[#b3a7a7]"
                        />
                      </mat-option>
                      <mat-option
                        class="hover:!bg-[#fae8e1]"
                        *ngFor="let stakeholder of stakeholders"
                        [value]="stakeholder?.stake_holder"
                      >
                        {{ stakeholder?.stake_holder }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="flex justify-end items-center sticky">
  <button
    (click)="handleBack()"
    type="button"
    class="save-btn !mr-[10px] !bg-[#fff]"
  >
    Back
  </button>
  <button
    class="save-btn shadow-[0px_4px_4px_rgba(0,0,0,0.25)] !font-medium"
    type="button"
    (click)="handleSubmit('save')"
  >
    <ng-container *ngIf="isLoadingSave; else normalTextSave">
      <div class="spinner"></div>
    </ng-container>
    <ng-template #normalTextSave>Save</ng-template>
  </button>
  <button
    class="next-btn"
    type="button"
    (click)="handleSubmit('next')"
    [ngClass]="{ 'loading-btn': isLoadingNext }"
  >
    <ng-container *ngIf="isLoadingNext; else normalTextNext">
      <div class="spinner"></div>
    </ng-container>
    <ng-template #normalTextNext>Next</ng-template>
  </button>
</div>
